import React, { PropsWithChildren } from "react";

import {
  Box,
  Link,
  Center,
  Container,
  Grid,
  GridItem,
  Stack,
  Text,
} from "@chakra-ui/react";

import useTranslations from "../../../hooks/useTranslations";

import Logo from "../../Logo";

const LoginLayout: React.FC<PropsWithChildren<{ title: string }>> = ({
  title,
  children,
}) => {
  const t = useTranslations();

  return (
    <Grid
      h="100vh"
      maxHeight="100vh"
      overflow="hidden"
      w="100vw"
      templateRows="repeat(1, 1fr)"
      templateColumns="repeat(3, 1fr)"
    >
      <GridItem
        h="full"
        maxHeight="100vh"
        overflow="hidden"
        display={{ base: "none", lg: "flex" }}
        bg="primary.50"
        flexDirection="column"
        py="16"
      >
        <Center flexGrow={1}>
          <Logo width="150px" />
        </Center>
        <Stack
          spacing="0.5"
          fontSize="sm"
          fontWeight="semibold"
          alignItems="center"
        >
          <Text>{t("login.noAccountYet")}</Text>
          <Link isExternal href="https://www.klarahr.com/demo" color="brand">
            {t("login.askDemo")}
          </Link>
        </Stack>
      </GridItem>
      <GridItem colSpan={{ base: 3, lg: 2 }}>
        <Container
          maxWidth="lg"
          h="full"
          maxHeight="100vh"
          overflow="hidden"
          display="flex"
          flexDirection="column"
          py={{ base: "16", lg: "28" }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent={{ base: "flex-start", lg: "center" }}
            flexGrow={1}
          >
            <Stack spacing="10" pb="7">
              <Center display={{ base: "flex", lg: "none" }}>
                <Logo width="150px" />
              </Center>
              <Text
                fontSize={{ base: "xl", lg: "3xl" }}
                fontWeight="semibold"
                textAlign={{ base: "center", lg: "start" }}
              >
                {title}
              </Text>
            </Stack>
            {children}
          </Box>
          <Stack
            pt="4"
            display={{ base: "flex", lg: "none" }}
            spacing="0.5"
            fontSize="sm"
            fontWeight="semibold"
            alignItems="center"
            flexShrink={0}
          >
            <Text>{t("login.noAccountYet")}</Text>
            <Link isExternal href="https://www.klarahr.com/demo" color="brand">
              {t("login.askDemo")}
            </Link>
          </Stack>
        </Container>
      </GridItem>
    </Grid>
  );
};

export default React.memo(LoginLayout);
